import { Spinner } from "@npco/zeller-design-system";

import { Layout } from "../shared/layout";
import { Prompt } from "../shared/prompt";

export function PageInitialising({
	onClose,
	onLogout,
	pending,
}: Required<Pick<Layout.Props, "onClose" | "onLogout" | "pending">>) {
	return (
		<Layout logo onClose={onClose} onLogout={onLogout} pending={pending}>
			<Prompt image={<Spinner size="lg" />} title="Fetching your information" />
		</Layout>
	);
}
